import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["correspondence"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      correspondencePackageList: build.query<
        CorrespondencePackageListApiResponse,
        CorrespondencePackageListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/`,
          params: {
            package_type: queryArg.packageType,
            recipient_carrier_id: queryArg.recipientCarrierId,
            recipient_party_id: queryArg.recipientPartyId,
            recipient_police_department_id:
              queryArg.recipientPoliceDepartmentId,
            recipient_provider_id: queryArg.recipientProviderId,
          },
        }),
        providesTags: ["correspondence"],
      }),
      correspondencePackageCreate: build.mutation<
        CorrespondencePackageCreateApiResponse,
        CorrespondencePackageCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/`,
          method: "POST",
          body: queryArg.createCorrespondencePackage,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondenceComponentList: build.query<
        CorrespondenceComponentListApiResponse,
        CorrespondenceComponentListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/`,
        }),
        providesTags: ["correspondence"],
      }),
      correspondenceComponentCreate: build.mutation<
        CorrespondenceComponentCreateApiResponse,
        CorrespondenceComponentCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/`,
          method: "POST",
          body: queryArg.createCorrespondenceComponent,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondenceComponentRetrieve: build.query<
        CorrespondenceComponentRetrieveApiResponse,
        CorrespondenceComponentRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/${queryArg.id}/`,
        }),
        providesTags: ["correspondence"],
      }),
      correspondenceComponentUpdate: build.mutation<
        CorrespondenceComponentUpdateApiResponse,
        CorrespondenceComponentUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateCorrespondenceComponent,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondenceComponentDestroy: build.mutation<
        CorrespondenceComponentDestroyApiResponse,
        CorrespondenceComponentDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondenceComponentReorder: build.mutation<
        CorrespondenceComponentReorderApiResponse,
        CorrespondenceComponentReorderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/reorder/`,
          method: "POST",
          body: queryArg.reorderComponentsRequest,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondenceComponentSearchTemplates: build.query<
        CorrespondenceComponentSearchTemplatesApiResponse,
        CorrespondenceComponentSearchTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/search_templates/`,
          params: {
            category: queryArg.category,
            include_global: queryArg.includeGlobal,
            search: queryArg.search,
          },
        }),
        providesTags: ["correspondence"],
      }),
      correspondenceComponentValidateAll: build.mutation<
        CorrespondenceComponentValidateAllApiResponse,
        CorrespondenceComponentValidateAllApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.packageId}/components/validate_all/`,
          method: "POST",
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageRetrieve: build.query<
        CorrespondencePackageRetrieveApiResponse,
        CorrespondencePackageRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/`,
        }),
        providesTags: ["correspondence"],
      }),
      correspondencePackageUpdate: build.mutation<
        CorrespondencePackageUpdateApiResponse,
        CorrespondencePackageUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateCorrespondencePackage,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageDestroy: build.mutation<
        CorrespondencePackageDestroyApiResponse,
        CorrespondencePackageDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageDefaultEmailContent: build.query<
        CorrespondencePackageDefaultEmailContentApiResponse,
        CorrespondencePackageDefaultEmailContentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/default-email-content/`,
        }),
        providesTags: ["correspondence"],
      }),
      correspondencePackageRender: build.mutation<
        CorrespondencePackageRenderApiResponse,
        CorrespondencePackageRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/render/`,
          method: "POST",
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageResetComponents: build.mutation<
        CorrespondencePackageResetComponentsApiResponse,
        CorrespondencePackageResetComponentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/reset-components/`,
          method: "POST",
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageSend: build.mutation<
        CorrespondencePackageSendApiResponse,
        CorrespondencePackageSendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/send/`,
          method: "POST",
          body: queryArg.sendPackageRequest,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageTransmissionUpdate2: build.mutation<
        CorrespondencePackageTransmissionUpdate2ApiResponse,
        CorrespondencePackageTransmissionUpdate2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/transmission/`,
          method: "PATCH",
          body: queryArg.patchedTransmission,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageTransmissionUpdate: build.mutation<
        CorrespondencePackageTransmissionUpdateApiResponse,
        CorrespondencePackageTransmissionUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/transmission/`,
          method: "DELETE",
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageUpload: build.mutation<
        CorrespondencePackageUploadApiResponse,
        CorrespondencePackageUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/upload/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["correspondence"],
      }),
      correspondencePackageValidateAll: build.query<
        CorrespondencePackageValidateAllApiResponse,
        CorrespondencePackageValidateAllApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/${queryArg.id}/validate-all/`,
        }),
        providesTags: ["correspondence"],
      }),
      correspondencePackageGetOrCreateForCoverage: build.mutation<
        CorrespondencePackageGetOrCreateForCoverageApiResponse,
        CorrespondencePackageGetOrCreateForCoverageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/correspondence-packages/get-or-create-for-coverage/`,
          method: "POST",
          body: queryArg.createCorrespondencePackage,
        }),
        invalidatesTags: ["correspondence"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type CorrespondencePackageListApiResponse =
  /** status 200  */ CorrespondencePackageSchema[];
export type CorrespondencePackageListApiArg = {
  matterId: string;
  /** Filter by package type */
  packageType?: string;
  /** Filter by recipient insurance carrier ID */
  recipientCarrierId?: string;
  /** Filter by recipient party ID */
  recipientPartyId?: string;
  /** Filter by recipient police department ID */
  recipientPoliceDepartmentId?: string;
  /** Filter by recipient medical provider ID */
  recipientProviderId?: string;
};
export type CorrespondencePackageCreateApiResponse =
  /** status 201  */ CorrespondencePackageSchema;
export type CorrespondencePackageCreateApiArg = {
  matterId: string;
  createCorrespondencePackage: CreateCorrespondencePackage;
};
export type CorrespondenceComponentListApiResponse =
  /** status 200  */ CorrespondenceComponentSchema[];
export type CorrespondenceComponentListApiArg = {
  matterId: string;
  packageId: string;
};
export type CorrespondenceComponentCreateApiResponse =
  /** status 201  */ CorrespondenceComponentSchema;
export type CorrespondenceComponentCreateApiArg = {
  matterId: string;
  packageId: string;
  createCorrespondenceComponent: CreateCorrespondenceComponent;
};
export type CorrespondenceComponentRetrieveApiResponse =
  /** status 200  */ CorrespondenceComponentSchema;
export type CorrespondenceComponentRetrieveApiArg = {
  id: string;
  matterId: string;
  packageId: string;
};
export type CorrespondenceComponentUpdateApiResponse =
  /** status 200  */ CorrespondenceComponentSchema;
export type CorrespondenceComponentUpdateApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  patchedUpdateCorrespondenceComponent: UpdateCorrespondenceComponent;
};
export type CorrespondenceComponentDestroyApiResponse = unknown;
export type CorrespondenceComponentDestroyApiArg = {
  id: string;
  matterId: string;
  packageId: string;
};
export type CorrespondenceComponentReorderApiResponse =
  /** status 200  */ CorrespondenceComponentSchema;
export type CorrespondenceComponentReorderApiArg = {
  matterId: string;
  packageId: string;
  reorderComponentsRequest: ReorderComponentsRequest;
};
export type CorrespondenceComponentSearchTemplatesApiResponse =
  /** status 200  */ TemplateSearchResults;
export type CorrespondenceComponentSearchTemplatesApiArg = {
  /** Filter by template category */
  category?: string;
  /** Include global templates (default: true) */
  includeGlobal?: boolean;
  matterId: string;
  packageId: string;
  /** Search term for template name/description */
  search?: string;
};
export type CorrespondenceComponentValidateAllApiResponse =
  /** status 200  */ PackageValidationResponse;
export type CorrespondenceComponentValidateAllApiArg = {
  matterId: string;
  packageId: string;
};
export type CorrespondencePackageRetrieveApiResponse =
  /** status 200  */ CorrespondencePackageSchema;
export type CorrespondencePackageRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageUpdateApiResponse =
  /** status 200  */ CorrespondencePackageSchema;
export type CorrespondencePackageUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateCorrespondencePackage: UpdateCorrespondencePackage;
};
export type CorrespondencePackageDestroyApiResponse = unknown;
export type CorrespondencePackageDestroyApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageDefaultEmailContentApiResponse =
  /** status 200  */ EmailContentDefaults;
export type CorrespondencePackageDefaultEmailContentApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageRenderApiResponse =
  /** status 200  */ RenderWorkflowResponse;
export type CorrespondencePackageRenderApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageResetComponentsApiResponse =
  /** status 200  */ CorrespondencePackageSchema;
export type CorrespondencePackageResetComponentsApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageSendApiResponse =
  /** status 200  */ SendPackageResponse;
export type CorrespondencePackageSendApiArg = {
  id: string;
  matterId: string;
  sendPackageRequest: SendPackageRequest;
};
export type CorrespondencePackageTransmissionUpdate2ApiResponse =
  /** status 200  */ CorrespondencePackageSchema;
export type CorrespondencePackageTransmissionUpdate2ApiArg = {
  id: string;
  matterId: string;
  patchedTransmission: Transmission;
};
export type CorrespondencePackageTransmissionUpdateApiResponse =
  /** status 200  */ CorrespondencePackageSchema;
export type CorrespondencePackageTransmissionUpdateApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageUploadApiResponse =
  /** status 201  */ CorrespondencePackageSchema;
export type CorrespondencePackageUploadApiArg = {
  id: string;
  matterId: string;
  body: {
    blob_id?: string;
  };
};
export type CorrespondencePackageValidateAllApiResponse =
  /** status 200  */ PackageValidationResponse;
export type CorrespondencePackageValidateAllApiArg = {
  id: string;
  matterId: string;
};
export type CorrespondencePackageGetOrCreateForCoverageApiResponse =
  /** status 200  */
    | CorrespondencePackageSchema
    | /** status 201  */ CorrespondencePackageSchema;
export type CorrespondencePackageGetOrCreateForCoverageApiArg = {
  matterId: string;
  createCorrespondencePackage: CreateCorrespondencePackage;
};
export type CorrespondencePackageType =
  | "hipaa_authorization"
  | "foia_request"
  | "lien_notice"
  | "demand_package"
  | "follow_up"
  | "subpoena"
  | "premises_lor"
  | "custom";
export type RenderStatus =
  | "draft"
  | "missing_fields"
  | "queued_for_render"
  | "generating"
  | "ready"
  | "published"
  | "error";
export type PackageSource = "generated" | "manually_uploaded";
export type CustomUserSchema = {
  id: string | string;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  is_firm_admin?: boolean;
  avatar?: string | null;
  signature?: string | null;
};
export type ContactSourceType = "manual" | "contact_handle";
export type ContactSource = {
  source_type?: ContactSourceType;
  handle_id?: (string | string) | null;
  handle_type?: string | null;
};
export type ContactCardType =
  | "medical_provider"
  | "police_department"
  | "insurance_carrier"
  | "party"
  | "custom";
export type EmailTransmission = {
  display_name: string;
  source?: ContactSource;
  entity_type?: ContactCardType;
  entity_id?: (string | string) | null;
  type?: "email";
  email: string;
  subject?: string | null;
  body?: string | null;
  cc?: string[] | null;
  conversation_id?: string | null;
};
export type FaxTransmission = {
  display_name: string;
  source?: ContactSource;
  entity_type?: ContactCardType;
  entity_id?: (string | string) | null;
  type?: "fax";
  fax_number: string;
  cover_message?: string | null;
  cover_page_from?: string | null;
  cover_page_to?: string | null;
};
export type DestinationAddress = {
  address_line1: string;
  address_line2?: string | null;
  city: string;
  state: string;
  zip_code: string;
  country?: string;
};
export type PostGridMailingClass =
  | "first_class"
  | "standard_class"
  | "express"
  | "certified"
  | "certified_return_receipt"
  | "registered"
  | "usps_first_class"
  | "usps_standard_class"
  | "usps_eddm"
  | "usps_express_2_day"
  | "usps_express_3_day"
  | "usps_first_class_certified"
  | "usps_first_class_certified_return_receipt"
  | "usps_first_class_registered"
  | "usps_express_3_day_signature_confirmation"
  | "usps_express_3_day_certified"
  | "usps_express_3_day_certified_return_receipt"
  | "ca_post_lettermail"
  | "ca_post_personalized"
  | "ca_post_neighbourhood_mail"
  | "ca_post_registered"
  | "ca_post_expedited_with_signature"
  | "ca_post_expedited"
  | "ca_post_xpresspost_with_signature"
  | "ca_post_xpresspost"
  | "royal_mail_first_class"
  | "royal_mail_standard_class"
  | "au_post_regular"
  | "au_post_second_class"
  | "ups_express_overnight"
  | "ups_express_2_day"
  | "ups_express_3_day"
  | "ups_express_3_day_signature_confirmation"
  | "ups_express_3_day_adult_signature_confirmation";
export type ChequeTransmission = {
  display_name: string;
  source?: ContactSource;
  entity_type?: ContactCardType;
  entity_id?: (string | string) | null;
  type?: "mailed_cheque";
  address: DestinationAddress;
  amount: string;
  memo?: string | null;
  mailing_class?: PostGridMailingClass;
  include_return_envelope?: boolean;
};
export type MailTransmission = {
  display_name: string;
  source?: ContactSource;
  entity_type?: ContactCardType;
  entity_id?: (string | string) | null;
  type?: "mailed_letter";
  address: DestinationAddress;
  mailing_class?: PostGridMailingClass;
  include_return_envelope?: boolean;
};
export type TransmissionStatus =
  | "pending"
  | "sending"
  | "sent"
  | "delivered"
  | "failed"
  | "bounced";
export type MessageStubSchema = {
  id: string | string;
  transmission_status?: TransmissionStatus;
  transmission_error?: string | null;
  created_at: string;
  postgrid_letter_id?: (string | string) | null;
  postgrid_cheque_id?: (string | string) | null;
};
export type ComponentType =
  | "template"
  | "global_template"
  | "matter_blob"
  | "static_document"
  | "external_file"
  | "generated_content"
  | "merge_document"
  | "signed_authorization_merge";
export type MissingFieldInfo = {
  field_id: string;
  field_name: string;
  field_source: string;
  context_key?: string | null;
};
export type BlobSchema = {
  id: string | string;
  name: string;
  original_filename: string | null;
  collection_id: string | string;
  collection_name: string;
  file_hash: string;
  file_size: number;
  file_extension: string | null;
  file_mime_type: string | null;
  download_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type TemplateFormat = "PDF" | "DOCX" | "HTML" | "SMS" | "EXTERNAL";
export type TemplateCategory =
  | "HIPAA_COVERSHEET"
  | "HIPAA_AUTHORIZATION"
  | "FOIA_LETTER"
  | "LIEN_NOTICE"
  | "RETAINER"
  | "LOR_GENERIC"
  | "LOR_FIRST_PARTY"
  | "LOR_THIRD_PARTY"
  | "LOR_HEALTH"
  | "WELCOME_LETTER"
  | "DROP_LETTER"
  | "JOINT_VENTURE_NOTICE"
  | "CLIENT_COMMUNICATION"
  | "MEDICAL_RECORDS_REQUEST"
  | "AFFIDAVIT"
  | "LETTER_OF_PROTECTION"
  | "PRESERVATION_LETTER"
  | "PIP_DEMAND"
  | "OTHER";
export type TemplateScope = "GLOBAL" | "FIRM";
export type ExternalSystem = "ADOBE_SIGN";
export type TemplateStatus = "ACTIVE" | "SUPERSEDED" | "ARCHIVED";
export type ReadTemplate = {
  id: string | string;
  name: string;
  display_name?: string | null;
  description?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  body?: string | null;
  file_url?: string | null;
  external_system?: ExternalSystem;
  external_id?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  sample_render_status?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  version: number;
  version_group: string;
  deleted_at?: string | null;
  created_at: string;
  modified_at: string;
};
export type CorrespondenceComponentSchema = {
  component_type: ComponentType;
  order?: number;
  overrides?: {
    [key: string]: string;
  };
  id: string | string;
  package_id: string | string;
  status?: RenderStatus;
  v2_template_id?: (string | string) | null;
  global_template_key?: string | null;
  blob_id?: (string | string) | null;
  static_document_id?: (string | string) | null;
  external_url?: string | null;
  generated_content_key?: string | null;
  merge_source_blob_id?: (string | string) | null;
  coverage_1p_id?: (string | string) | null;
  coverage_3p_id?: (string | string) | null;
  coverage_health_id?: (string | string) | null;
  content_hash?: string | null;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  };
  rendered_pdf_url?: string | null;
  rendered_docx_url?: string | null;
  error_message?: string | null;
  rendered_input_hash?: string | null;
  needs_rerender?: boolean;
  blob?: BlobSchema;
  template?: ReadTemplate;
};
export type RecipientContactSource = {
  entity_type: ContactCardType;
  entity_id: string;
  entity_name: string;
  source_label?: string | null;
};
export type RecipientContactHandle = {
  /** Composite ID for the contact point */
  id: string;
  /** Database ID of the ContactHandle model */
  handle_id: string;
  display_name: string;
  label?: string | null;
  fax_number?: string | null;
  email?: string | null;
  address?: DestinationAddress;
  supported_channels: ("fax" | "mailed_letter" | "mailed_cheque" | "email")[];
  handle_type: string;
  source: RecipientContactSource;
};
export type EmailContentDefaults = {
  subject: string;
  body: string;
};
export type CorrespondencePackageSchema = {
  id: string | string;
  matter_id: string | string;
  package_type: CorrespondencePackageType;
  status: RenderStatus;
  package_source: PackageSource;
  created_by?: CustomUserSchema;
  treatment_request_id?: (string | string) | null;
  investigation_request_id?: (string | string) | null;
  coverage_id?: (string | string) | null;
  transmission?:
    | (
        | ({
            type: "email";
          } & EmailTransmission)
        | ({
            type: "fax";
          } & FaxTransmission)
        | ({
            type: "mailed_cheque";
          } & ChequeTransmission)
        | ({
            type: "mailed_letter";
          } & MailTransmission)
      )
    | null;
  transmitted_at?: string | null;
  transmitted_by?: CustomUserSchema;
  message?: MessageStubSchema;
  recipient_entity_type?: ContactCardType;
  recipient_id?: (string | string) | null;
  recipient_display_name?: string | null;
  rendered_pdf_url?: string | null;
  rendered_docx_url?: string | null;
  completed_package_id?: (string | string) | null;
  download_url?: string | null;
  components?: CorrespondenceComponentSchema[];
  error_message?: string | null;
  created_at?: string | null;
  modified_at?: string | null;
  is_transmitted?: boolean;
  is_mutable?: boolean;
  recipient_contacts?: RecipientContactHandle[];
  email_defaults?: EmailContentDefaults;
  coverage_carrier_name?: string | null;
  transmission_destination_display?: string | null;
  default_overrides?: {
    [key: string]: string;
  };
  can_lookup_recipient_contacts?: boolean;
  recipient_locked_to_coverage?: boolean;
};
export type CorrespondenceErrorResponse = {
  error: string;
  code?: string | null;
  details?: {
    [key: string]: (string | boolean | string[]) | null;
  } | null;
};
export type CreateCorrespondencePackage = {
  matter_id?: (string | string) | null;
  package_type: CorrespondencePackageType;
  treatment_request_id?: (string | string) | null;
  investigation_request_id?: (string | string) | null;
  coverage_id?: (string | string) | null;
  recipient_entity_type?: ContactCardType;
  recipient_entity_id?: (string | string) | null;
  recipient_display_name?: string | null;
  with_defaults?: boolean;
};
export type CreateCorrespondenceComponent = {
  component_type: ComponentType;
  order?: number;
  overrides?: {
    [key: string]: string;
  };
  v2_template_id?: (string | string) | null;
  global_template_key?: string | null;
  blob_id?: (string | string) | null;
  static_document_id?: (string | string) | null;
  external_url?: string | null;
  generated_content_key?: string | null;
  merge_source_blob_id?: (string | string) | null;
  coverage_1p_id?: (string | string) | null;
  coverage_3p_id?: (string | string) | null;
  coverage_health_id?: (string | string) | null;
};
export type UpdateCorrespondenceComponent = {
  order?: number | null;
  overrides?: {
    [key: string]: string;
  } | null;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  } | null;
  coverage_1p_id?: (string | string) | null;
  coverage_3p_id?: (string | string) | null;
  coverage_health_id?: (string | string) | null;
};
export type ComponentOrderMapping = {
  component_id: string | string;
  order: number;
};
export type ReorderComponentsRequest = {
  components: ComponentOrderMapping[];
};
export type TemplateSearchResult = {
  id: string | string;
  name: string | null;
  display_name: string | null;
  description: string | null;
  template_category: string;
  template_type: string;
  is_firm_template: boolean;
  is_default?: boolean;
};
export type TemplateSearchResults = {
  results: TemplateSearchResult[];
};
export type FieldType =
  | "TEXT"
  | "DATE"
  | "CHECKBOX"
  | "IMAGE"
  | "ARRAY"
  | "SIGNATURE"
  | "INITIALS";
export type FieldSource = "MANUAL" | "CONTEXT" | "SIGNING";
export type ContextCategoryMeta = {
  label: string;
  binding_key?: string | null;
  entity_absent_hint?: string | null;
};
export type MatterContextFieldType =
  | "text"
  | "date"
  | "number"
  | "boolean"
  | "datetime"
  | "image"
  | "array";
export type ArrayItemProperty = {
  key: string;
  type: MatterContextFieldType;
  label: string;
  required?: boolean;
};
export type PdfPosition = {
  x: number;
  y: number;
  width: number;
  height: number;
};
export type ReadTemplateField = {
  id: string | string;
  template_id: string | string;
  reference: string;
  field_type: FieldType;
  source: FieldSource;
  context_key?: string | null;
  context_category?: string | null;
  context_category_meta?: ContextCategoryMeta;
  array_item_schema?: ArrayItemProperty[] | null;
  array_item_keys?: string[] | null;
  default_value?: string | null;
  required: boolean;
  display_name?: string | null;
  pdf_page_number?: number | null;
  pdf_position?: PdfPosition;
  created_at: string;
  modified_at: string;
};
export type AnnotationFieldInfo = {
  field_id: string;
  field_name: string;
  field_source: string;
  context_key?: string | null;
  current_value?: string | null;
  value_source?: string | null;
  is_missing?: boolean;
};
export type ComponentValidationResult = {
  component_id: string | string;
  is_valid: boolean;
  missing_fields_count: number;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  };
  template_fields?: ReadTemplateField[] | null;
  annotation_fields?: AnnotationFieldInfo[] | null;
  component_type?: ComponentType;
  order?: number | null;
};
export type PackageValidationResponse = {
  status: string;
  package_id: string | string;
  total_components: number;
  valid_components: number;
  components: ComponentValidationResult[];
  matter_context?: {
    [key: string]: string | null;
  };
};
export type UpdateCorrespondencePackage = {
  status?: RenderStatus;
  completed_package_id?: (string | string) | null;
  package_source?: PackageSource;
  error_message?: string | null;
  clear_recipient?: boolean;
  recipient_entity_type?: ContactCardType;
  recipient_entity_id?: (string | string) | null;
  recipient_display_name?: string | null;
};
export type RenderWorkflowResponse = {
  workflow_id: string;
  status: RenderStatus;
  package_id: string | string;
};
export type SendPackageResponse = {
  workflow_id: string;
  status: TransmissionStatus;
  message_id?: (string | string) | null;
};
export type SendPackageRequest = {
  package_id: string | string;
  transmission?:
    | (
        | ({
            type: "email";
          } & EmailTransmission)
        | ({
            type: "fax";
          } & FaxTransmission)
        | ({
            type: "mailed_cheque";
          } & ChequeTransmission)
        | ({
            type: "mailed_letter";
          } & MailTransmission)
      )
    | null;
  user_id?: (string | string) | null;
};
export type Transmission =
  | ({
      type: "email";
    } & EmailTransmission)
  | ({
      type: "fax";
    } & FaxTransmission)
  | ({
      type: "mailed_cheque";
    } & ChequeTransmission)
  | ({
      type: "mailed_letter";
    } & MailTransmission);
export const {
  useCorrespondencePackageListQuery,
  useCorrespondencePackageCreateMutation,
  useCorrespondenceComponentListQuery,
  useCorrespondenceComponentCreateMutation,
  useCorrespondenceComponentRetrieveQuery,
  useCorrespondenceComponentUpdateMutation,
  useCorrespondenceComponentDestroyMutation,
  useCorrespondenceComponentReorderMutation,
  useCorrespondenceComponentSearchTemplatesQuery,
  useCorrespondenceComponentValidateAllMutation,
  useCorrespondencePackageRetrieveQuery,
  useCorrespondencePackageUpdateMutation,
  useCorrespondencePackageDestroyMutation,
  useCorrespondencePackageDefaultEmailContentQuery,
  useCorrespondencePackageRenderMutation,
  useCorrespondencePackageResetComponentsMutation,
  useCorrespondencePackageSendMutation,
  useCorrespondencePackageTransmissionUpdate2Mutation,
  useCorrespondencePackageTransmissionUpdateMutation,
  useCorrespondencePackageUploadMutation,
  useCorrespondencePackageValidateAllQuery,
  useCorrespondencePackageGetOrCreateForCoverageMutation,
} = injectedRtkApi;
